import { objIterate } from "./Utils";

export async function ResponseFormating(menu, result, side = "") {
  try {
    // //console.log(result)
    let response = null;
    let faceImage = null;
    let signImage = null;
    // //console.log("selectmenu", menu, result);
    if (menu === "AADHARMASKING") {
      response = result.detail.response_image;
      return response;
    } else if (menu === "DDREADER") {
      response = result;

      const formateData = objIterate(response, ["recordId"]);

      // //console.log("iterate response", formateData);
      return { data: formateData };
    } else if (menu === "CHEQUEREADER") {
      response = result.data;
      const { micr, ...rest } = response;
      const firstSix = micr.substring(0, 6);
      const nextNine = micr.substring(7, 16);
      const formattedObj = {
        ...rest,
        "Cheque No": firstSix,
        MICR: nextNine,
      };
      const formateData = objIterate(formattedObj, ["status"]);

      // //console.log("iterate response", formateData);
      return { data: formateData };
    } else if (menu === "PANREADER") {
      response = result.data;
      faceImage = result.faceImage;
      signImage = result.signImage;
      const formateData = objIterate(response, ["utc_time_stamp"]);
      // //console.log("iterate response", formateData);
      return { data: formateData, faceImage: faceImage, signImage: signImage };
    } else if (menu === "MEXICANVOTERIDREADER") {
      response = result.data;

      const formateData = objIterate(response, ["utc_time_stamp"]);
      // //console.log("iterate response", formateData);
      return { data: formateData };
    } else if (menu === "AADHARREADER") {
      response = result?.data || ''

      faceImage = side === "Front" ? result?.data?.faceImage : null;
      const formateData = objIterate(response, [
        "utc_time_stamp",
        "recordId",
        "retrievalStatus",
      ]);
      //console.log("iterate response", response, formateData);
      if (result.face_detection_status === "SUCCESS") {
        return { data: formateData, faceImage: faceImage };
      } else {
        return { data: formateData };
      }
    } else if (menu === "PASSPORTREADER") {
      response =
        side === "Front"
          ? result?.data?.status === "success"
            ? result.data
            : Object.keys(result?.data).length > 0 ? {
              ...result?.data,
              maritalStatus: result?.data?.maritalStatus ? "Yes" : "No",
            } : ""
          : result.status_res === "SUCCESS"
          ? {
              ...result.data,
              maritalStatus: result?.data?.maritalStatus ? "Yes" : "No",
            }
          : result?.data;
      faceImage = side === "Front" ? result?.data?.faceImage : null;
      const formateData = objIterate(response, ["status"]);
      // //console.log("iterate response", formateData);
      if (side === "Front") {
        return { data: formateData, faceImage: faceImage };
      } else {
        return { data: formateData };
      }
    } else if (menu === "VOTERIDREADER") {
      response = result.data;
      const formateData = objIterate(response, ["Utc time_stamp"]);
      // //console.log(formateData);

      // //console.log(data);
      return { data: formateData };
    } else if (menu === "EMIRATESIDREADER") {
      response = result.data;
      const formateData = objIterate(response, ["utc_time_stamp"]);
      // //console.log(formateData);

      // //console.log(data);
      return { data: formateData };
    } else if (menu === "QATARIDREADER") {
      response = result.data;
      const formateData = objIterate(response, ["utc_time_stamp"]);
      // //console.log(formateData);

      // //console.log(data);
      return { data: formateData };
    } else if (menu === "MEXICANINVOICEPARSER") {
      response =
        result?.data?.layout_dict[0]?.Structure_Results?.key_value_pair;
      const formateData = objIterate(response, []);
      // //console.log(response);

      // //console.log(formateData);
      return { data: formateData };
    } else if (menu === "qrreader") {
      response = result;
      const formateData = objIterate(response, ["recordId", "status"]);
      // //console.log(response);

      // //console.log(formateData);
      return { data: formateData };
    } else if (menu === "MALAYSIANDRIVINGLICENSE") {
      response = result.data;
      const formateData = objIterate(response, ["utc_time_stamp", "status"]);
      // //console.log(response);

      // //console.log(formateData);
      return { data: formateData };
    } else if (menu === "MALAYSIANIDREADER") {
      response = result.data;
      const formateData = objIterate(response, ["utc_time_stamp", "status"]);
      // //console.log(response);

      // //console.log(formateData);
      return { data: formateData };
    } else if (menu === "IMAGETOJSON") {
      response = result.data;
      const formateData = objIterate(response, ["utc_time_stamp", "status"]);
      // //console.log(response);

      // //console.log(formateData);
      return { data: formateData };
    } else if (menu === "CHECKSHEETPROCESSING") {
      response = result.defect_details;
      const formateData = objIterate({ Status: result.status, ...response }, [
        "utc_time_stamp",
        "status",
      ]);
      // //console.log(response);

      // //console.log(formateData);
      return { data: formateData };
    } else if (menu === "EVISAEXTRACTION") {
      response = result.data;
      //as now we formate evisa like this in fure this need to change
      const { eta_number, ...rest } = response;

      const formateData = objIterate({ ...rest }, ["utc_time_stamp", "status"]);
      console.log(formateData);
      let data = [
        {
          key: "ETA Number",
          value: eta_number || "N/A",
        },

        ...formateData,
      ];
      // //console.log(response);

      // //console.log(formateData);
      return { data };
    } else if (menu === "FEDERALBANKACCOUNTOPENINGFORM") {
      response = result
      let sanitizedData = [];
      for (const key in response) {
        if (Object.hasOwnProperty.call(response, key)) {
          let value = response[key]
            .replace("[", "")
            .replace("]", "")
            .replace(/'/g, "");

          sanitizedData.push({ key: key, value: value.split(",") });
        }
      }
      // //console.log(formateData);
      return { data: sanitizedData };
    }

    else if (menu === "AOFEXTRACTION") {
      response = result?.detail;
      const formateData = objIterate(response, [
        "utc_time_stamp",
        "status",
      ]);
      return { data: formateData };
    } else if (menu === "FEDERALBANKACCOUNTOPENINGFORM") {
      response = result?.error_details;
      let sanitizedData = [];
      for (const key in response) {
        if (Object.hasOwnProperty.call(response, key)) {
          let value = response[key]
            .replace("[", "")
            .replace("]", "")
            .replace(/'/g, "");

          sanitizedData.push({ key: key, value: value.split(",") });
        }
      }
      // //console.log(formateData);
      return { data: sanitizedData };
    }
    else if (menu === "TRANSCOMPDFEXTRATION") {
      response = result?.data;
      const formateData = objIterate(response, [
        "utc_time_stamp",
        "status",
      ]);
      return { data: formateData };
    }
    // not in use now
    //  else if (menu === "Passport Verification") {
    //   response = result.validity;
    //   // //console.log("isvalid",result.validity)
    //   if (response === "not_valid") {
    //     return {
    //       data: ` Your Passport is ${response.replace("_", " ")}`,
    //       isValid: false,
    //     };
    //   } else {
    //     return {
    //       data: ` Your Passport is ${response.replace("_", " ")}`,
    //       isValid: true,
    //     };
    //   }
    // }
    //  else if (menu === "Voter ID Verification") {
    //   response = result.validity;
    //   if ((response = "not_valid")) {
    //     return {
    //       data: ` Your Voter ID is ${response.replace("_", " ")}`,
    //       isValid: false,
    //     };
    //   } else {
    //     return {
    //       data: ` Your Voter ID is ${response.replace("_", " ")}`,
    //       isValid: true,
    //     };
    //   }
    // }
    //  else if (menu === "Voter ID Reader") {
    //   response = result.data;
    //   const formateData = (response);
    //   // //console.log(formateData);
    //   let data = { data: formateData };
    //   // //console.log(data);
    //   return data;
    // }

    // else if (menu === "Invoice Reader") {
    //   response = result.layout_dict;
    //   let TableData = response[0].Tables;
    //   let formateData = [];
    //   let extractData = response[1].Structure_Results.key_value_pair;
    //   const formatedTableData = TableData.map((data) => {
    //     // // //console.log(
    //     //   response,
    //     //   TableData,
    //     //   JSON.parse(data).table_json.columns,
    //     //   JSON.parse(data).table_json.rows,
    //     //   JSON.parse(data).table_json.cell
    //     // );

    //     // formateData.push({
    //     //   row: JSON.parse(data).table_json.rows,
    //     //   col: JSON.parse(data).table_json.columns,
    //     //   data: JSON.parse(data).table_json.cell,
    //     // });
    //     // (JSON.parse(data) ?
    //     // )
    //     //console.log(data.find((itm) => itm.includes("No visible text in page")));
    //     if (!data.includes("No visible text in page")) {
    //       return {
    //         row: JSON.parse(data)?.table_json?.rows,
    //         col: JSON.parse(data)?.table_json?.columns,
    //         data: JSON.parse(data)?.table_json?.cell,
    //       };
    //     }
    //   });

    //   return { data: extractData, TableData: formatedTableData };
    // }
    // national id
    // else if (menu === "National ID Reader") {
    //   response = result.data;

    //   const formateData = response;
    //   // //console.log("iterate response", formateData);
    //   return { data: formateData };
    // }
  } catch (error) {
    //console.log(error)
  }
}
